import { Injectable } from '@angular/core';
import { DriverNotesHistory } from '@core/models/api-response.model';
import { APIService } from '@core/services/api.service';
import { Utility } from '@shared/services/utility.abstract';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DriverService {
  private previousUrl: string | null = null;

  constructor(
    private readonly apiService: APIService,
  ) {
   }

  setPreviousUrl(url: string) {
    this.previousUrl = url;
  }

  getPreviousUrl(): string {
    return this.previousUrl;
  }
  addDriverNotesHistoryByDriverIdForSuperAdmin(req) {
    return this.apiService.postWithAllResponse('User/AddDriverNotesHistoryByDriverIdForSuperAdmin', req);
  }

  getDriverNotesHistoryByDriverIdForSuperAdmin(driverId: string) {
    const timeZone = Utility.getLocalTimeZone();
    return this.apiService.get<DriverNotesHistory[]>(`User/GetDriverNotesHistoryByDriverIdForSuperAdmin?driverId=${driverId}&timeZone=${timeZone}`);
  }

  addPaymentMethod(DriverId:string){
    return this.apiService.postWithAllResponse(`Stripe/AddPaymentMethod?DriverId=${DriverId}`);
  };

  addPaymentMethodInRecurringCase(request){
    return this.apiService.postWithAllResponse('Stripe/AddPaymentMethod',request);
  };


  getAllPatmentMethodsList(DriverId:string){
    return this.apiService.getWithAllResponse(`Stripe/GetAllPaymentMethodsList?DriverId=${DriverId}`);
  };

  setDefualtPaymentMethod(request){
    return this.apiService.postWithAllResponse('Stripe/SetDefualtPaymentMethod',request);
  };

  deletePaymentMethod(request){
    return this.apiService.deleteWithBodyRequest('Stripe/DeletePaymentMethod',request)
  };

  CreatePaymentByDefaultPaymentMethod(request){
    return this.apiService.postWithAllResponse('BookingSlot/CreatePaymentByDefaultPaymentMethod',request)
  }

  createPaymentByDefaultPaymentMethodGroupBooking(request){
    return this.apiService.postWithAllResponse('BookingSlot/CreatePaymentByDefaultPaymentMethodGroupBooking',request)
  }

  RePaymentSession(request){
    return this.apiService.postWithAllResponse('User/CreateRePaymentSession',request)
  }

  paymentUrlMethod(request){
    return this.apiService.postWithAllResponse('Stripe/GetPaymentUrlByBookingIdOrInvoiceId',request);
  }

  createInvoicePaymentOffline(request: any) {
    return this.apiService.postWithAllResponse('BookingSlot/CreateInvoicePaymentOffline', request)
  }
  deleteNoteById(notesId: string): Observable<any> {
    return this.apiService.deleteWithBodyRequest(`User/DeleteDriverNotesById?Id=${notesId}`);
  }

  updateRoleToGroupOperator(request): Observable<any> {
    return this.apiService.postWithAllResponse('Reports/UpdateRole', request);
  }
}
